import Button from "../Buttons/Button";
import { buttonNameConstants } from "../../../constants";

import { connect } from "react-redux";
import { shopifyActions } from "../../../redux/actions";

const ViewOrderNotification = ({
  orderId,
  currentStore,
  getShopifyOrderNotificationModalDetails,
}) => {
  const handleViewOrderClick = async () => {
    getShopifyOrderNotificationModalDetails(currentStore?.id, orderId);
  };

  return (
    <>
      <Button
        handleClick={handleViewOrderClick}
        label={buttonNameConstants.VIEW_ORDER}
      />
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  isPrintLabelModal: state.printer.isPrintLabelModal,
  isAuthenticated: state.authentication.isAuthenticated,
  isDraftConfirmationModal: state.transaction.isDraftConfirmationModal,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getShopifyOrderNotificationModalDetails: (storeId, orderId) =>
    dispatch(
      shopifyActions.getShopifyOrderNotificationModalDetails(storeId, orderId)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewOrderNotification);
